'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rcQueueAnim = require('rc-queue-anim');

var _rcQueueAnim2 = _interopRequireDefault(_rcQueueAnim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _rcQueueAnim2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/basic/queue-anim/index.jsx
 ** module id = 482
 ** module chunks = 0
 **/